/* eslint-disable @typescript-eslint/no-unsafe-return */
import type { ZodSchema, z } from 'zod';
import { parseZodError } from './serviceErrorLogger';

export const validateSchemaAsync =
  <S extends ZodSchema>(schema: S) =>
  async (data: Promise<z.input<S>>): Promise<z.infer<S>> => {
    const resolved = await data;
    const parsedResult = schema.safeParse(resolved);

    if (!parsedResult.success) {
      const parsedErrors = parsedResult.error ? parseZodError(parsedResult.error) : [];
      throw new Error(parsedErrors.join('\n'));
    }

    return parsedResult.data;
  };
